<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        {{ username }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a">修改密码</el-dropdown-item>
        <el-dropdown-item command="b">切换账户</el-dropdown-item>
        <el-dropdown-item command="c">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <modify-pass
      :formVisible="formVisible"
      :ruleFormProps="ruleFormProps"
      @closeDialogForm="closeDialogForm"
    ></modify-pass>
  </div>
</template>
<script>
import ModifyPass from "@/pages/account/user-manage/modifypass";
export default {
  // name: "self-header",
  data() {
    return {
      formVisible: false,
      ruleFormProps: {
        // userName: "",
        oldPass: "",
        newPass: "",
      },
      title: document.title,
    };
  },
  computed: {
    username() {
      return JSON.parse(localStorage.getItem("userInfo")).username || "用户";
    },
  },
  components: {
    ModifyPass,
  },
  methods: {
    // handleCommand(command) {
    //   if (command == "a") {
    //     this.formVisible = true;
    //   } else if (command == "b") {
    //     this.$router.push("/login");
    //   } else {
    //     this.$store.dispatch("logout", code => {
    //       if (code == "0") {
    //         this.$router.push("/login");
    //       } else {
    //         this.$notify({
    //           title: "error",
    //           message: "登出失败",
    //           type: "error"
    //         });
    //       }
    //     });
    //   }
    // },
    handleCommand(command) {
      if (command == "a") {
        this.formVisible = true;
      } else if (command == "b") {
        // this.$router.push("/login");
        let param = { isSwitchAccount: 1 };
        this.$store.dispatch("ssologout", {
          param,
          cb: (data) => {
            console.log(data);
          },
        });
      } else {
        let param = {};
        this.$store.dispatch("ssologout", {
          param,
          cb: (data) => {
            console.log(data);
          },
        });
      }
    },
    closeDialogForm() {
      this.ruleFormProps = { oldPass: "", newPass: "" };
      this.formVisible = false;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.task-btn {
  margin-right: 10px;
  font-size: 14px;
  cursor: pointer;
}
.el-row {
  height: 100%;
  line-height: 50px;
  color: #fff;
}
.el-dropdown-link {
  cursor: pointer;
  // color: #fff;
}
.header-right {
  text-align: right;
}
</style>
